angular.module('webtrader').component('cubicOptions', {
  bindings: {
    quote: '=',
  },
  templateUrl: BASE_URL+'templates/component.cubicOptions.html',
  controller: function (Account, Quotes, Trades) {
    this.quotes = Quotes

    this.volume = 1
    this.minutes = 1
    this.inc = (val, add) => (typeof val !== 'number' || isNaN(val))? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add))

    this.higher = () => this.openTrade(0)
    this.lower = () => this.openTrade(1)

    this.openTrade = (cmd) => {
      Trades.order({
        cmd: cmd,
        symbol: this.quote.symbol,
        volume: this.volume,
        expiration: this.minutes,
      })
    }
  }
})
